// @ts-ignore userLanguage is just for IE11
export const language: string = navigator.userLanguage || navigator.language;

export const referrer = () => {
  let referrerStr = '';
  try {
    referrerStr = window.top.document.referrer;
  } catch (e) {
    if (window.parent) {
      try {
        referrerStr = window.parent.document.referrer;
      } catch (e1) {
        referrerStr = '';
      }
    }
  }
  if (referrerStr === '') {
    referrerStr = window.document.referrer;
  }
  return referrerStr;
};

export const timezoneOffset = new Date().getTimezoneOffset();

export const timezoneString = String(String(new Date()).split('(')[1]).split(
  ')'
)[0];

// This fills out the 'page' section of an event
export function getAll() {
  const docHeight = Math.max(
    // @ts-ignore TODO: reference window.parent ?
    document.documentElement.clientHeight,
    document.body.scrollHeight,
    // @ts-ignore TODO: reference window.parent ?
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    // @ts-ignore TODO: reference window.parent ?
    document.documentElement.offsetHeight
  );
  const docWidth = Math.max(
    // @ts-ignore TODO: reference window.parent ?
    window.document.documentElement.clientWidth,
    // @ts-ignore TODO: reference window.parent ?
    window.document.documentElement.offsetWidth,
    // @ts-ignore TODO: reference window.parent ?
    window.document.documentElement.scrollWidth
  );
  return {
    page_document_size_height: docHeight,
    page_document_size_width: docWidth,
    page_page_offset_left: Math.max(
      window.pageXOffset || document.body.scrollLeft || 0
    ),
    page_page_offset_top: Math.max(
      window.pageYOffset || document.body.scrollTop || 0
    ),
    page_title: window.document.title,
    page_url: window.location.href,
    page_viewport_height: window.innerHeight,
    page_viewport_width: window.innerWidth,
    page_language: language,
    page_referrer: referrer(),
    page_timezone_offset: timezoneOffset,
    page_timezone_string: timezoneString,
    timestamp_created: Date.now(),
  };
}
